module.exports = __webpack_public_path__ + "static/media/hospital.659831e8.jpg";